import React, { JSX } from 'react';
import { PATHS } from 'src/common/constants';
import Anchor from 'src/components/Anchor';
import Auth from 'src/layouts/Auth/Auth';
import Button from 'src/components/Button';
import Loader from 'src/components/Loader';
import NewPasswordFields from 'src/components/NewPasswordFields';
import LinkValidation from 'src/pages/LinkValidation/LinkValidation';
import { Images, variables } from 'src/Tenants';
import {
  useLinkBasedPasswordFlow,
  UseLinkBasedPasswordFlowReturn,
} from 'src/SharedCustomHooks/UseLinkBasedPasswordFlow/useLinkBasedPasswordFlow';

const Activate = (): JSX.Element => {
  const {
    linkStatus,
    password,
    confirmPassword,
    requirements,
    passwordsMismatch,
    canSubmit,
    isSubmitting,
    updatePassword,
    updateConfirmPassword,
    submit,
  }: UseLinkBasedPasswordFlowReturn = useLinkBasedPasswordFlow('Activation');

  if (linkStatus.kind === 'validating') {
    return <Loader center={true} />;
  }

  if (linkStatus.kind === 'invalid') {
    return <LinkValidation message={linkStatus.message} />;
  }

  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    void submit();
  };

  return (
    <Auth
      title="Activate Account"
      backgroundImage={Images.signInImage}
      content={(
        <div className="sign-in">
          <form onSubmit={onSubmit}>
            <div className="sign-in-header">
              <div className="sign-in-headline">
                {variables.userActivationMessage}
              </div>
            </div>
            <NewPasswordFields
              password={password}
              confirmPassword={confirmPassword}
              onPasswordChange={updatePassword}
              onConfirmPasswordChange={updateConfirmPassword}
              requirements={requirements}
              passwordsMismatch={passwordsMismatch}
              passwordLabel="Password"
            />
            {isSubmitting ? <Loader center={true} /> : null}
            <div className="sign-in-button">
              <Button
                label="Submit Password"
                color="teal"
                submit
                block
                disabled={!canSubmit || isSubmitting}
              />
            </div>

            <div className="sign-in-footer">
              Remember your password?{' '}
              <Anchor path={PATHS.AUTH_SIGN_IN} label="Sign In" />
            </div>
          </form>
        </div>
      )}
    />
  );
};

export default Activate;
